import { OrganizationType } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

/** Leasing companies and car dealerships hold cars an outside customer drives. */
export const organizationHoldsExternalCars = (organizationType: { value: string } | null | undefined): boolean =>
  organizationType?.value === OrganizationType.LEASING_COMPANY ||
  organizationType?.value === OrganizationType.CAR_DEALERSHIP;

export const ORGANIZATION_TYPE_FILTER_OPTIONS: {
  label: string;
  value: OrganizationType;
  icon: NoddiIconName;
}[] = [
  { label: 'B2B customer', value: OrganizationType.B2B_CUSTOMER, icon: 'BriefcaseBusiness' },
  { label: 'Car dealership', value: OrganizationType.CAR_DEALERSHIP, icon: 'Store' },
  { label: 'Insurance company', value: OrganizationType.INSURANCE_COMPANY, icon: 'Shield' },
  { label: 'Leasing company', value: OrganizationType.LEASING_COMPANY, icon: 'Car' },
  { label: 'Municipality', value: OrganizationType.MUNICIPALITY, icon: 'Building2' },
  { label: 'Other', value: OrganizationType.OTHER, icon: 'CircleHelp' },
  { label: 'Supplier', value: OrganizationType.SUPPLIER, icon: 'Truck' },
  { label: 'Tire hotel', value: OrganizationType.TIRE_HOTEL, icon: 'Warehouse' }
];
